import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin, Typography } from "antd";

/**
 * Right-pane "generating" state — shown while a new note version is being
 * regenerated in the background (Claude-style working feedback) before it
 * opens automatically.
 */
const NoteGenerating = () => (
  <Flex
    vertical
    align="center"
    justify="center"
    gap={16}
    style={{ height: "100%", minHeight: 320, padding: 24, textAlign: "center" }}
  >
    <Spin indicator={<LoadingOutlined style={{ fontSize: 32, color: "#6366F1" }} spin />} />
    <Flex vertical gap={4} align="center">
      <Typography.Text style={{ fontSize: 15, fontWeight: 600, color: "#111827" }}>
        Regenerating your note…
      </Typography.Text>
      <Typography.Text style={{ fontSize: 13, color: "#6B7280" }}>
        Superdoc is creating a new version. It'll open here automatically when ready.
      </Typography.Text>
    </Flex>
  </Flex>
);

export default NoteGenerating;
